import { DoubleColor } from '@/__generated__/graphql'

export const getDoubleWinningColor = (rollNumber: number | null) => {
  if (rollNumber === null) {
    return null
  }

  if (rollNumber === 0) {
    return DoubleColor.Green
  }

  if (rollNumber % 2 === 0) {
    return DoubleColor.Black
  }

  return DoubleColor.Red
}
